// Traductions en Français
export const fr = {
  common: {
    welcome: "Bienvenue",
    logout: "Déconnexion",
    login: "Connexion",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    cancel: "Annuler",
    save: "Enregistrer",
    delete: "Supprimer",
    edit: "Modifier",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    search: "Rechercher",
    filter: "Filtrer",
    close: "Fermer",
  },
  login: {
    title: "Connexion",
    subtitle: "Accédez à votre compte Auriga",
    button: "Se connecter avec Authentik",
    checking: "Vérification de la session...",
    redirecting: "Redirection...",
  },
  dashboard: {
    title: "Tableau de bord",
    welcome: "Bienvenue",
    userInfo: "Informations utilisateur",
    email: "E-mail",
    id: "ID",
    apiInfo: "Informations API",
    noUserData: "Aucune information utilisateur disponible.",
    sections: "Sections disponibles",
    qualityDashboard: "Tableau de bord Qualité",
    maintenanceDashboard: "Tableau de bord Maintenance",
    adminDashboard: "Tableau de bord Administration",
    noAccess: "Vous n'avez pas accès aux sections spécialisées. Contactez l'administrateur pour obtenir des permissions.",
    permissions: "Informations sur les permissions",
    factories: "Usines",
    roles: "Rôles",
    departments: "Départements",
    groups: "Groupes",
    none: "Aucun",
    noneFound: "Aucun",
  },
  quality: {
    title: "Tableau de bord Qualité",
    permissions: "Informations sur les permissions",
    accessChecks: "Vérifications d'accès",
    factoryAccess: "Accès à",
    roleIn: "Rôle",
    features: "Fonctionnalités Qualité",
    inspections: "Gestion des inspections",
    qualityControl: "Contrôle qualité",
    nonConformities: "Rapports de non-conformité",
    trends: "Analyse des tendances",
  },
  maintenance: {
    title: "Tableau de bord Maintenance",
    permissions: "Informations sur les permissions",
    accessChecks: "Vérifications d'accès",
    factoryAccess: "Accès à",
    roleIn: "Rôle",
    features: "Fonctionnalités Maintenance",
    planning: "Planification de la maintenance",
    workOrders: "Ordres de travail",
    equipment: "Gestion des équipements",
    history: "Historique de maintenance",
  },
  admin: {
    title: "Tableau de bord Administration",
    permissions: "Informations sur les permissions",
    accessChecks: "Vérifications d'accès",
    group: "Groupe",
    features: "Fonctionnalités Administration",
    users: "Gestion des utilisateurs",
    system: "Configuration du système",
    reports: "Rapports administratifs",
    audit: "Audit et journaux",
  },
  navigation: {
    dashboards: "Tableaux de bord",
  },
  errors: {
    notAuthenticated: "Non authentifié",
    accessDenied: "Accès refusé",
    noPermission: "Vous n'avez pas la permission d'accéder à cette section.",
    requirements: "Exigences",
    factory: "Usine",
    department: "Département",
    role: "Rôle",
    group: "Groupe",
    backToDashboard: "Retour au tableau de bord",
  },
};








